import axios from 'axios';
import Api from "./Api";

class UserAPI extends Api{


    getMyProfile(apiOption){
        let path = "/user/me";
        let endpoint =  this.combineUrl(this.nrtmApiHost,path);
        //let endpoint =  this.combineUrl(this.apiHost,path);
        return this._get(endpoint,apiOption).then(response =>  response)
    }

    signin(userId,password,apiOption){
        
        let body = {
            "userId": userId,
            "password": password
        };

        let path = "/auth/mykk/signin";
        let endpoint =  this.combineUrl(this.nrtmApiHost,path);
        return this._post(endpoint,body,apiOption).then(response =>  response)

    }

}

let _api = new UserAPI();

export default _api;